import { faRocket } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Space } from "antd"
import ThemableButton from "./ThemableButton"
import { cyan } from "@ant-design/colors"

type Props = {
  disabled?: boolean
  onClick?: () => void
}

const ViewJobSummaryButton = ({ disabled, onClick }: Props) => {
  return <ThemableButton colorPrimary={cyan.primary!} type="primary" size="large" disabled={disabled} onClick={onClick}>
    <Space><FontAwesomeIcon icon={faRocket} />View Job Summary</Space>
  </ThemableButton>
}

export default ViewJobSummaryButton
